import { render, staticRenderFns } from "./ReportQuestionDialog.vue?vue&type=template&id=4edb13fa&scoped=true&"
import script from "./ReportQuestionDialog.vue?vue&type=script&lang=js&"
export * from "./ReportQuestionDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReportQuestionDialog.vue?vue&type=style&index=0&id=4edb13fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edb13fa",
  null
  
)

export default component.exports